import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import QuizSvgData from 'pathfinder/modules/shared/assets/quiz.svg';
import styles from '../styles/ImageOverlay.module.scss';
export default function ImageOverlay({ backgroundColor, textColor }) {
    return (_jsxs("div", Object.assign({ className: styles.wrapper, style: { backgroundColor, color: textColor } }, { children: [_jsx(QuizSvgData, { className: styles.quizSvg, style: { '--path-fill-color': textColor } }, void 0), "Quiz"] }), void 0));
}
